<template>
  <div class="question-cont">
    <div class="name">안녕하세요!!</div>
    <div>개발자 이불입니다~</div>
    <div>이 페이지는 평소 넷플릭스를 즐겨보던 개발자가</div>
    <div>충동적으로 개발한 페이지입니다.</div>
    <br>

    <div>나혼자 사용할거라 생각했지만</div>
    <div>꽤 많은 사람들이 접속해 주셨습니다.</div>
    <br>

    <div>그래서 혹시 사람들이 이용하는데</div>
    <div>불편한 점이 없는지 걱정됐습니다.</div>
    <br>

    <div>사용하다 더 좋은 개선점이나 아이디어가 있으면</div>
    <div>주저 말고 저에게 제안해주세요~</div>
    <div>페이지에 대한 궁금점도 문의해 주세요!</div>
    <div><i>(예를 들면 "사람들이 어떤 장르를 검색할까" 같은??)</i></div>
    <br>

    <a href="mailto:sibotno1@gmail.com">sibotno1@gmail.com</a>

    <div>아무쪼록 즐겁게 사용해주세요!</div>
    <br>

    <div><b>그럼 영화 재밌게 보세요~~</b></div>
  </div>
</template>

<script>
  export default {
  }
</script>

<style lang="scss" scoped>
  .question-cont {
    padding: 30px 0 50px 0;
    font-size: 16px;
    color: #333333;
    line-height: 1.7;
    text-align: center;

    .name {
      font-size: 24px;
      font-weight: bold;
    }
    .button {
      color: #1976d2;
      user-select: none;
      cursor: pointer;
      border-bottom: 1px solid #1976d2;
    }
  }
  .mt12 {
    margin-top: 12px;
  }
  .mt20 {
    margin-top: 20px;
  }
  .mt28 {
    margin-top: 28px;
  }
  .center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>
